import React from "react";
import Image from "next/image";
import TeamCard from "./TeamCard";
import missionImg from "../../public/images/company/mission.jpg";
import visionImg from "../../public/images/company/vision.jpg";
import TeamData from "../../data/company.json";
import Separator from "@/pages/separator";

const Company = () => {
  return (
    <>
      <div className="container">
        <div class="vision-card row">
          <div class="col-lg-6 col-12">
            <div className="vision-img">
              <Image
                width={200}
                height={200}
                src={visionImg}
                alt="vision image"
                class="image"
              />
            </div>
          </div>
          <div class="col-lg-6 col-12">
            <h2>Vision</h2>
            <h5>Connecting the world with smart businesses</h5>
            <p>
              Here at Viatick, we envision a world where tasks are made simpler
              with data from AIOT technology.
            </p>
          </div>
        </div>
        <div class="mission-card row">
          <div class="col-lg-6 col-12">
            <h2>Mission</h2>
            <h5>Connect The World Through Data</h5>
            <p>
              By leveraging on Data, Viatick hopes to transform businesses with
              the use of AI to make a bigger and greener impact.
            </p>
          </div>
          <div class="col-lg-6 col-12">
            <div className="mission-img">
              <Image src={missionImg} alt="mission image" class="image" />
            </div>
          </div>
        </div>
        <Separator top={true} />
        <div className="text-center mt--10 mb--10">
          <h2>Our Team</h2>
          <p class="team-desc">
            Our team consists of dedicated personnel who are passionate about
            solving problems and enhancing productivity.
          </p>
        </div>
        <div class="profile-container row mt--10 mb--20">
          {TeamData.team.map((value, index) => (
            <div
              class="profile-card col-lg-4 col-md-4 col-sm-6 col-12 mb-20"
              key={index}
            >
              <TeamCard
                image={value.image}
                name={value.name}
                role={value.role}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Company;
